import { createStore } from "vuex";
import requests from "../request"
export default createStore({
    state: {
        isShow: true,
        projectData: [], // 用户主数据
        projectShow: true,
        rolelstraData: [], // 角色主数据请求
        roleData:{}, // 路由权限模块
        tablist:true,
        loginInvalid:false,
        sidebarStatic:false,
        showLeftMenu:true,
        token:'',
    },
    actions: {
        roleData({commit}){
            requests({
                url: '/system/role/selectAllRole',
                method: 'post',
                params: {
                    page: '5',
                    rows: '5',
                },
                headers: {
                    "Token": localStorage.getItem('token'),
                },
            }).then((res) => {
                commit("GETROLEDATA",res.data.data.result)
            });
        },
        tabshow({ commit }) {
            commit("ISSHOW")
        },
        loginInvalid({commit}){
            commit("LOGININVALID")
        },
        projectRequest({ commit }) {
            requests({
                url: "/product/selectAllProduct",
                headers: { "Token": localStorage.getItem("token") },
                method: "post"
            }).then(res => {
                console.log(localStorage.getItem("token"));
                commit("PROJECT", res)
            })
        },
        porejctShow({ commit }) {
            commit("PORJECTSHOW")
        },
       async see({commit},data){
            await requests({
                url:"/system/role/selectAllRoleOrMenu",
                headers:{"Token":localStorage.getItem("token")},
                params:{id:data.id},
                method:"post"
            }).then(res=>{
                commit("SEE",res)
            })
        }
    },
    mutations: {
        LOGININVALID(state){
            state.loginInvalid = !state.loginInvalid
        },
        PORJECTSHOW(state) {
            state.projectShow = !state.projectShow
        },
        ISSHOW(state) {
            state.isShow = !state.isShow
        },
        PROJECT(state, data) {
            state.projectData = data
        },
        GETROLEDATA(state,data){
            state.rolelstraData=data
        },
        SEE(state,data){
            localStorage.setItem("roleData",data.data.data)
            state.roleData=data.data.data
            state.tablist=!(state.tablist)
        }
    },
    getters: {

    },

    modules: {

    }
})
